import * as React from 'react';
export const MHSvg = React.forwardRef(function MHSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F79A59',
        d: 'M0 11.5 16 4v3L0 12z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M16 7v3L.06 12.49A2.004 2.004 0 0 1 0 12l16-5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M16 7v3l-1 .156V7.312L16 7ZM1 12.344l-.94.147A2.004 2.004 0 0 1 0 12l1-.313v.657Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M3.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z',
      }),
    ),
  );
});
MHSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MH = {
  category: 'flag',
  colorable: false,
  name: 'MH',
  svg: MHSvg,
};
